import {Component, Input, Optional} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-button-back',
    template: `
    <button *ngIf="isModal" type="button" class="btn btn-secondary" (click)="modalRef.hide()"><i class="fa fa-undo"></i> {{ "back" | translate}} </button>

    <button *ngIf="!isModal" type="button" class="btn btn-secondary"
                     [queryParams]="queryparams" fragment="{{ fragment }}" [routerLink]="[route]" ><i class="fa fa-undo"></i> {{ "back" | translate}} </button> `,
    standalone: false
})
export class ButtonBackComponent {

  constructor(@Optional() public modalRef?: BsModalRef){};

  @Input() route = '..';

  @Input() queryparams = {};

  @Input() fragment: null;

  @Input() isModal = false;
}

